









































































































































import MarketSelect from '@/components/MarketSelect.vue';
import {TableHeaders} from '@/interfaces/components-data';
import {BootstrapSelectBox, SelectBox} from '@/interfaces/global-data';
import {
    GrabItem,
    grabItemLabels,
    ICallGrabbingDTO,
    IErrors,
    IGrabbingConfigDTO,
    IGrabSchedule,
    ISaveGrabbingConfigDTO,
} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import LocalData, {ErrorsMap} from '@/mixins/local-data';
import GrabbingSchedule from '@/pages/grabber-config/GrabbingScheduleEdit.vue';
import GrabbingScheduleView from '@/pages/grabber-config/GrabbingScheduleView.vue';
import {BvModalEvent} from 'bootstrap-vue';
import {Component, Mixins} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';

@Component({
    components: {
        GrabbingScheduleView,
        GrabbingSchedule,
        MarketSelect,
        vSelect,
    },
})
export default class GrabberConfigs extends Mixins(LocalData, Http) {
    tradingNetworks: Array<BootstrapSelectBox<number>> = [];

    fields: TableHeaders[] = [
        {key: 'tradingNetId', label: this.$t('settings.grabber.table.tradingNetId') as string},
        {key: 'tradingNetName', label: this.$t('settings.grabber.table.tradingNetName') as string},
        {key: 'packageSize', label: this.$t('settings.grabber.table.packageSize') as string},
        {key: 'url', label: this.$t('settings.grabber.table.url') as string},
        {key: 'schedules', label: this.$t('settings.grabber.table.schedules') as string},
        {key: 'actions', label: this.$t('settings.grabber.table.actions') as string},
    ]
    pageSize = 20;
    pageNumber = 0;
    totalNumber = 0;
    modalTitle = this.$t('settings.grabber.createSettings') as string;
    isNew = true;

    grabItemsOptions: Array<SelectBox<GrabItem>> = [
        {value: GrabItem.ASSORTMENT, label: grabItemLabels.ASSORTMENT},
        {value: GrabItem.COMPETITORS, label: grabItemLabels.COMPETITORS},
        {value: GrabItem.SALES, label: grabItemLabels.SALES},
    ];
    callGrabDTO: ICallGrabbingDTO | null = null;
    formErrors: ErrorsMap = {};

    showFormError: boolean = false;

    configToSave: ISaveGrabbingConfigDTO = {
        tradingNetId: -1,
        url: '',
        packageSize: 500,
        accessToken: null,
        emailAddresses: '',
        assortmentSchedule: this.getDefaultSchedule(),
        salesSchedule: this.getDefaultSchedule(),
        competitorSchedule: this.getDefaultSchedule(),

    };

    getMessage(form: string, field: string): string | null {
        if (!this.formErrors.hasOwnProperty(form)) {
            return null;
        }

        if (!this.formErrors[form].hasOwnProperty(field)) {
            return null;
        }
        return this.formErrors[form][field].message;
    }

    getDefaultSchedule(): IGrabSchedule {
        return {
            time: '00:00:00',
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
            sunday: true,
        }

    }

    loadConfigs(ctx: any, callback: (items: IGrabbingConfigDTO[]) => void) {
        this.httpLoadGrabberConfigs(ctx.currentPage, this.pageSize)
                .then((r) => {
                    this.totalNumber = r.data.totalElements;
                    callback(r.data.content)
                })
                .catch((e) => {
                    this.$log.error('Error occurred while load config', e)
                    callback([])
                    this.showError(this.$t('settings.grabber.messages.loadConfigsError') as string)
                });
    }

    hideSaveModal() {
        (this.$refs.saveConfigModal as any).hide();
    }

    showSaveModal() {
        (this.$refs.saveConfigModal as any).show();
        this.isNew = true;
    }

    clearModalInfo() {
        delete this.formErrors['saveConfigForm'];
        this.showFormError = false;
        this.modalTitle = this.$t('settings.grabber.createSettings') as string;
        this.isNew = true;
        this.configToSave = {
            tradingNetId: -1,
            url: '',
            packageSize: 500,
            accessToken: null,
            emailAddresses: '',
            assortmentSchedule: this.getDefaultSchedule(),
            salesSchedule: this.getDefaultSchedule(),
            competitorSchedule: this.getDefaultSchedule(),
        };
    }

    saveConfig(event: BvModalEvent) {
        delete this.formErrors['saveConfigForm'];
        this.showFormError = false;
        event.preventDefault();
        this.httpSaveGrabberConfig(this.configToSave)
                .then(() => {
                    (this.$refs.apiSettings as any).refresh();
                    this.hideSaveModal();
                })
                .catch((e) => {
                    if (e.response) {
                        if (e.response.status === 400) {
                            const errors = e.response.data as IErrors;
                            this.renderErrors('saveConfigForm', errors);
                        } else {
                            this.showError(this.$t('settings.grabber.messages.saveConfigsError') as string)
                        }
                    }
                });
    }

    loadTradingNetworks() {
        if (this.isNew) {
            this.httpLoadTradingNetworks()
                    .then((r) => {
                        this.tradingNetworks = r.data.map((i) => {
                            return {
                                value: i.id,
                                text: i.tradingName,
                            }
                        });
                    })
        }
    }

    editConfig(config: IGrabbingConfigDTO) {
        this.isNew = false;
        this.configToSave = {
            tradingNetId: config.tradingNetId,
            url: `${config.url}`,
            emailAddresses: `${config.emailAddresses}`,
            packageSize: config.packageSize,
            assortmentSchedule: Object.assign({}, config.assortmentSchedule),
            salesSchedule: Object.assign({}, config.salesSchedule),
            competitorSchedule: Object.assign({}, config.competitorSchedule),
            accessToken: null,
        };
        this.tradingNetworks = [];
        this.tradingNetworks.push({
            value: config.tradingNetId,
            text: config.tradingNetName,
        });
        (this.$refs.saveConfigModal as any).show();
    }

    deleteConfig(config: IGrabbingConfigDTO) {
        this.httpDeleteGrabberConfig(config.tradingNetId)
                .then((r) => {
                    if (r.status === 204) {
                        (this.$refs.apiSettings as any).refresh();
                    }
                });
    }

    openGrabberCall(config: IGrabbingConfigDTO) {
        (this.$refs.callGrabbing as any).show();
        this.callGrabDTO = {
            tradingNetId: config.tradingNetId,
            tradingNetName: config.tradingNetName,
            grabItems: [],
            salesDateFrom: null,
            salesDateTo: null,
        }
    }

    get isSalesGrabbingContains(): boolean {
        return this.callGrabDTO != null && this.callGrabDTO.grabItems.indexOf(GrabItem.SALES) !== -1
    }

    clearGrabConfig() {
        delete this.formErrors['callGrabForm'];
        this.showFormError = false;
        this.callGrabDTO = null;
    }

    callGrab(event: BvModalEvent) {
        delete this.formErrors['callGrabbing'];
        this.showFormError = false;
        event.preventDefault();
        if (this.callGrabDTO != null) {
            const toSend = Object.assign({}, this.callGrabDTO)
            if (toSend.salesDateFrom != null) {
                toSend.salesDateFrom = `${toSend.salesDateFrom}T00:00:00`
            }

            if (toSend.salesDateTo != null) {
                toSend.salesDateTo = `${toSend.salesDateTo}T00:00:00`
            }

            this.httpCallGrabbing(toSend)
                    .then(() => {
                        (this.$refs.callGrabbing as any).hide();
                        this.showInfo(this.$t('settings.grabber.messages.dataCollectionSuccess') as string);
                    })
                    .catch((e) => {
                        if (e.response) {
                            if (e.response.status === 400) {
                                const errors = e.response.data as IErrors;
                                this.renderErrors('callGrabbing', errors);
                            } else {
                                this.showError(this.$t('settings.grabber.messages.dataCollectionError') as string);
                            }
                        }
                    })
        }
    }

    selectGrabItems(selected: Array<SelectBox<GrabItem>>) {
        if (this.callGrabDTO != null) {
            this.callGrabDTO.grabItems = selected.map((i) => i.value);
        }
    }

    private renderErrors(form: string, errors: IErrors) {
        this.formErrors[form] = {};
        this.showFormError = true;
        errors.errors.forEach((e) => {
            this.formErrors[form][e.property] = e
        });
    }
}
